const normalizeBaseUrl = (value?: string | null): string => {
  if (!value) return '';
  return value.trim().replace(/\/+$/, '');
};

/**
 * Retourne l'URL de base pour l'API, avec /api ajouté une seule fois.
 * - En production, REACT_APP_API_URL doit être défini (sinon une erreur est levée).
 * - En développement, on retourne '/api' pour utiliser le proxy CRA.
 */
export const getApiBaseUrl = (): string => {
  const normalized = normalizeBaseUrl(process.env.REACT_APP_API_URL);

  if (!normalized) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('REACT_APP_API_URL doit être défini en production');
    }
    return '/api';
  }

  return `${normalized}/api`;
};

/**
 * Construit une URL complète à partir d'un chemin relatif à l'API.
 */
export const buildApiUrl = (path: string): string => {
  const base = getApiBaseUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};
